import { post } from '@/services/user/userService';

// -----------------------------
// API: SET TERMS OF SERVICE / MARKETING CONSENT
export const setConsent = async (termsAccepted: boolean, marketingConsent: boolean) => {
  return post('/api/consent/Set', { termsAccepted, marketingConsent }, '');
};
